<sh-form-group
  [invalid]="isControlInvalid$ | async"
  [required]="isControlRequired$ | async"
  [label]="label"
  [labelIcons]="labelIcons"
  [helpText]="helpText"
  [currentActionItems]="currentActionItems"
  [describeLabelId]="describeLabelId"
  [errorMsg]="errorMsg"
  [id]="controlId"
  [formGroupStyling]="formGroupStyling"
  >
  <div slot="inputPrefix">
    <ng-content></ng-content>
  </div>

  @if (canBeIndeterminate) {
    <sh-form-checkbox-list-complex-base [formControl]="control" [id]="controlId" [inline]="inline" [options]="options" [disabledMsg]="disabledMsg">
    </sh-form-checkbox-list-complex-base>
  } @else {
    <sh-form-checkbox-list-base [formControl]="control" [id]="controlId" [inline]="inline" [options]="options" [disabledMsg]="disabledMsg">
    </sh-form-checkbox-list-base>
  }

</sh-form-group>
